module.exports = __webpack_public_path__ + "static/media/picture-(37).9bfd3045.JPG";